module.exports = new __parcel__URL__("nuts-and-milk.423d34b4.jpg").toString();